export const CharSetForPhoneAndFax = /^[0-9+\-() ]+$/;
export const CharSetForDUNSNumber = /^[0-9\- ]+$/;

export const CurrencyTypeMultiple = 0;
export const CurrencyTypeUSD = 1;

export const ManualDataFeedFormat = 'manual';

export enum FeedMessageType {
    Vendor = 26,
    User = 22,
    GLAccount = 28,
    POUpload = 3, // AKA POValidation
    PODelivery = 5,
}

export enum DeliveryMethodOutbound {
    SFTP = 'Sftp',
    Email = 'Email',
    Oracle = 'OracleSupplierNetwork',
    Transcepta = 'TransceptaManager',
    Webservice = 'Webservice',
}

export enum FileType {
    PDF = 'PDF',
    TIFF = 'TIFF',
    XML = 'XML',
    XML1 = 'XML1',
    Other = 'Other',
}

export enum FileTypeId {
    PDF = 1,
    TIFF = 2,
    XML = 3,
    XML1 = 5,
    Other = 6,
}

export enum SftpProtocol {
    FTP = 1,
    FTPS = 2,
    SFTP = 3,
}

export const sftpProtocolOptions = {
    FTP: SftpProtocol.FTP,
    FTPS: SftpProtocol.FTPS,
    SFTP: SftpProtocol.SFTP,
};

export const webserviceOptions = [
    'SciQuest',
    'Ignite',
    'OracleFusionUploadFiletoUCm',
    'OracleERPObjectAttachmentService',
    'OracleInvoiceInterfaceWebService',
    'CaliberERP',
];

export enum DeliveryMethodInbound {
    Transcepta = 'Transcepta',
    Buyer = 'Buyer',
    Email = 'Email',
}

export enum DataFeed {
    Vendor = 'vendorFeedFormat',
    User = 'userFeedFormat',
    GLAccount = 'glAccountFeedFormat',
    POValidation = 'poValidationFeedFormat',
    PODelivery = 'poDeliveryFeedFormat',
}

export const InvoiceProfileInfinx = 1;

export enum ProfileExtendedData {
    DisablePO = 'DisablePO',
    DisableNonPO = 'DisableNonPO',
    GLConfidenceThreshold = 'GLConfidenceThreshold',
    GLAutoReleaseThreshold = 'GLAutoReleaseThreshold',
    DisablePOCM = 'DisablePOCM', // Disable PO CloudMatch
    ForceMatchOneLinePO = 'ForceMatchOneLinePO',
}

export const IDE_THRESHOLD_MIN = 0;
export const IDE_THRESHOLD_MAX = 700;
